import { JSX } from "react";

import { Theme } from "@mui/material";
import { Dayjs } from "dayjs";
import { TFunction } from "i18next";
import ReactDOMServer from "react-dom/server";
import { ChartTooltipFormatterParams } from "src/components/Dashboard/interfaces/DashboardComponentParams";

import { TooltipWrapper } from "../TooltipWrapper";

export function formatTooltipDate(date: Dayjs, pastDate?: Dayjs | null, t?: TFunction): string {
  const fmt = (d: Dayjs) =>
    t
      ? `${t(d.format("ddd"))} ${d.format("DD")} ${t(d.format("MMM"))}`
      : `${d.format("ddd")} ${d.format("DD")} ${d.format("MMM")}`;

  const current = fmt(date);
  const past = pastDate ? `${fmt(pastDate)}, ${pastDate.format("YYYY")}` : "";

  return past ? `${current} vs. ${past}` : current;
}

export function sortParamsByValue(params: ChartTooltipFormatterParams[]): ChartTooltipFormatterParams[] {
  return [...params].sort((a, b) => {
    const dataB = b.data as [string, number];
    const dataA = a.data as [string, number];
    return (dataB[1] ?? 0) - (dataA[1] ?? 0);
  });
}

export function renderTooltipWrapper(date: string, theme: Theme, children: JSX.Element | JSX.Element[]): string {
  return ReactDOMServer.renderToString(
    <TooltipWrapper date={date} theme={theme}>
      {children}
    </TooltipWrapper>
  );
}
